<template>
  <div v-if="!$store.getters.getCharts.length">
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="ffu-analytics">

      <!-- Dashboard loader -->
      <v-layout row>
        <v-flex xs12>
          <base-loader></base-loader>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <div v-else>
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="ffu-analytics">

      <!-- Dashboard heading -->
      <v-layout row wrap align-end>
        <v-flex xs12 sm6>
          <last-update-time
            :dashboard-id="id">
          </last-update-time>
        </v-flex>
        <v-flex xs12 sm6>
          <pdf-export
            v-if="pdfExport"
            :dashboard-id="id"
            :dashboard-name="name">
          </pdf-export>
        </v-flex>
      </v-layout>

      <!-- Dashboard filters -->
      <v-layout row wrap>
        <v-flex xs12>
          <filters
            :dashboard-id="id"
            @apply-filters="fetchDashboardData"
            @clear-filters="fetchDashboardData">
          </filters>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
      <!--KPI-->
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <widget-kpi
            widget-key="demo_totalOrders">
          </widget-kpi>
        </v-flex>
      </v-layout>
      <!-- row -->
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <chart-tree-map
            chart-key="exampleTreeMapKey"
            @open-dialog="openDialog($event)">
          </chart-tree-map>
        </v-flex>
      </v-layout>
      <!-- row -->
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <chart-pie
            chart-key="demo_serviceOrdersNumber"
            @open-dialog="openDialog($event)">
          </chart-pie>
        </v-flex>
      </v-layout>
      <!-- row -->
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <chart-line-date
            chart-key="demo_OrdersByAppointmentDate"
            @open-dialog="openDialog($event)">
          </chart-line-date>
        </v-flex>
      </v-layout>
      <!-- row -->
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <chart-line
            chart-key="demo_OrdersByHour"
            @open-dialog="openDialog($event)">
          </chart-line>
        </v-flex>
      </v-layout>
      <!-- row -->
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <chart-line
            chart-key="demo_BrandPerMonth"
            @open-dialog="openDialog($event)">
          </chart-line>
        </v-flex>
      </v-layout>
      <!-- row -->
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <chart-bar
            chart-key="demo_TopBrands"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <chart-bar-stacked
            chart-key="demo_TopBrands_stacked"
            @open-dialog="openDialog($event)">
          </chart-bar-stacked>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <chart-table
            chart-key="demo_tableData"
            @open-dialog="openDialog($event)">
          </chart-table>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex class="lib-link" xs12>
          <a href="https://www.amcharts.com/demos/" target="_blank">
          <v-btn class="ma-2" color="success" dark>AmCharts library
            <v-icon dark right>info</v-icon>
          </v-btn>
          </a>
        </v-flex>
      </v-layout>
      <!-- row -->
      <!-- chart dialog window -->
      <v-dialog max-width v-model="dialog" @input="closeDialog()">
        <v-card>
          <v-card-title class="subheading">
            {{ dialogTitle }}
            <v-spacer></v-spacer>
            <v-btn icon small class="ma-0" @click.stop="closeDialog()">
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="chart-wrapper">
              <component
                :is="dialogComponent"
                v-bind="dialogProperties"
                :from-dialog="true">
              </component>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus'
import { mapGetters, mapMutations } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
// import am4themesAnimated from '@amcharts/amcharts4/themes/animated'
// import am4themesMaterial from '@amcharts/amcharts4/themes/material'
// import { am4themesEfdThemeAchr } from '@/themes'
// import moment from 'moment'

import BaseLoader from '@/components/loaders/BaseLoader'
import LastUpdateTime from '@/components/LastUpdateTime'
import Filters from './DashboardDemoFilters'
import WidgetKpi from '@/components/charts/WidgetKpi'
import ChartBar from '@/components/charts/ChartBar'
import ChartBarStacked from '@/components/charts/ChartBarStacked'
import ChartPie from '@/components/charts/ChartPie'
import ChartLine from '@/components/charts/ChartLine'
import ChartLineDate from '@/components/charts/ChartLineDate'
import ChartLineRender from '@/components/charts/ChartLineRender'
import ChartLineDateRender from '@/components/charts/ChartLineDateRender'
import ChartBarRender from '@/components/charts/ChartBarRender'
import ChartBarStackedRender from '@/components/charts/ChartBarStackedRender'
import ChartTable from '@/components/charts/ChartTable'
import ChartTreeMap from '@/components/charts/ChartTreeMap'
import ChartTreeMapRender from '@/components/charts/ChartTreeMapRender'
// import PdfExport from '@/components/pdfExport'

// am4core.useTheme(am4themesAnimated)
// am4core.useTheme(am4themesMaterial)
// am4core.useTheme(am4themesEfdThemeAchr)
am4core.options.queue = true
export default {
  name: 'Demo',
  components: {
    BaseLoader,
    LastUpdateTime,
    Filters,
    WidgetKpi,
    ChartBar,
    ChartBarStacked,
    ChartPie,
    ChartLine,
    ChartLineRender,
    ChartLineDateRender,
    ChartLineDate,
    ChartBarRender,
    ChartTable,
    ChartTreeMap,
    ChartTreeMapRender,
    ChartBarStackedRender
    // PdfExport
  },
  data () {
    return {
      id: 'demo',
      name: 'Demo',
      charts: [
        {
          key: 'demo_serviceOrdersNumber',
          title: 'Pie chart',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'demo_totalOrders',
          title: 'KPI',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'demo_OrdersByAppointmentDate',
          title: 'Timeline',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'demo_OrdersByHour',
          title: 'Line chart',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'demo_BrandPerMonth',
          title: 'Brands per Month',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            displayLength: 12, // 12 for moths per year
            fillOpacity: 0, // fill of area below line
            tensionX: 1, // line smoothness
            strokeWidth: 2, // line thickness
            colorSteps: 1, // values color difference
            legend: true
          },
          data: [
            {
              'name': 1,
              'Toyota': 564,
              'Kia': 388,
              'Citroën': 222,
              'Alfa Romeo': 85
            },
            {
              'name': 2,
              'Toyota': 352,
              'Kia': 390,
              'Citroën': 250,
              'Alfa Romeo': 35
            },
            {
              'name': 3,
              'Toyota': 623,
              'Kia': 256,
              'Citroën': 180,
              'Alfa Romeo': 15
            },
            {
              'name': 4,
              'Toyota': 564,
              'Kia': 388,
              'Citroën': 302,
              'Alfa Romeo': 5
            },
            {
              'name': 5,
              'Toyota': 352,
              'Kia': 390,
              'Citroën': 450,
              'Alfa Romeo': 15
            },
            {
              'name': 6,
              'Toyota': 623,
              'Kia': 256,
              'Citroën': 85,
              'Alfa Romeo': 22
            },
            {
              'name': 7,
              'Toyota': 564,
              'Kia': 388,
              'Citroën': 222,
              'Alfa Romeo': 85
            },
            {
              'name': 8,
              'Toyota': 352,
              'Kia': 390,
              'Citroën': 250,
              'Alfa Romeo': 35
            },
            {
              'name': 9,
              'Toyota': 623,
              'Kia': 256,
              'Citroën': 180,
              'Alfa Romeo': 15
            },
            {
              'name': 10,
              'Toyota': 564,
              'Kia': 388,
              'Citroën': 302,
              'Alfa Romeo': 5
            },
            {
              'name': 11,
              'Toyota': 352,
              'Kia': 390,
              'Citroën': 450,
              'Alfa Romeo': 15
            },
            {
              'name': 12,
              'Toyota': 623,
              'Kia': 256,
              'Citroën': 85,
              'Alfa Romeo': 22
            }
          ],
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'demo_TopBrands',
          title: 'Bar chart',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            displayLength: 5
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value'
          }
        },
        {
          key: 'demo_TopBrands_stacked',
          title: 'Bar chart stacked',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            displayLength: 5
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value'
          }
        },
        {
          key: 'exampleTreeMapKey',
          title: 'TreeMap Chart',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            colorSteps: 3, // values color difference
            legend: true
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value'
          }
        },
        {
          key: 'demo_tableData',
          title: 'Table',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            totalItems: 0,
            descending: false,
            sortBy: null,
            page: 1,
            rowsPerPage: 10
          }
        }
      ],
      pdfExport: false,
      // dialog data
      dialog: false,
      dialogComponent: '',
      dialogTitle: '',
      dialogProperties: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedFiltersGen', 'getCharts', 'getChartByKey', 'translation', 'currency'
    ]),
    translatedChartTitles: {
      get () {
        return this.charts.map(chart => {
          chart.valueType && chart.valueType === 'money'
            ? chart.title = this.translation(chart.title, { currency: this.currency })
            : chart.title = this.translation(chart.title)
          return chart
        })
      }
    }
  },
  created () {
    this.setCharts(this.translatedChartTitles)
  },
  mounted () {
    this.fetchDashboardData()
  },
  beforeDestroy () {
    // empty charts from store
    this.setCharts([])
  },
  methods: {
    ...mapMutations({
      setCharts: 'SET_CHARTS'
    }),
    fetchDashboardData () {
      // emit event for fetching data from components
      eventBus.$emit('update-dashboard')
    },
    openDialog (dialogData) {
      this.$store.dispatch('fetchChartData', {
        key: dialogData.chartObj.key,
        settings: dialogData.chartObj.settings,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination: { ...dialogData.chartObj.pagination, rowsPerPage: dialogData.chartObj.data.metadata.total }
      }).then(() => {
        this.$log.info('dialogData', dialogData)
        // assign received data from clicked component to Dialog component
        this.dialogComponent = dialogData.chartType
        this.dialogProperties = {}
        this.dialogProperties = { chartKey: dialogData.chartObj.key }
        this.dialogTitle = this.getChartByKey(dialogData.chartObj.key).title
        this.dialog = true
      })
    },
    closeDialog () {
      // clear data for component
      this.dialogComponent = ''
      this.dialogProperties = {}
      this.dialogTitle = ''
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
  .loader-wrapper {
    position: relative;
    height: 50px;
  }
  .ffu-analytics {
  }
  .lib-link a{
    text-decoration: none;
  }
  @media only screen and (max-device-width: 700px) {
    .ffu-analytics {
    }
  }
</style>
